__turbopack_context__.v({
  "container": "IconButton-module-scss-module__RwXaAa__container",
  "disabled": "IconButton-module-scss-module__RwXaAa__disabled",
  "loading": "IconButton-module-scss-module__RwXaAa__loading",
  "overlay": "IconButton-module-scss-module__RwXaAa__overlay",
  "overlay-primary": "IconButton-module-scss-module__RwXaAa__overlay-primary",
  "overlay-secondary": "IconButton-module-scss-module__RwXaAa__overlay-secondary",
  "primary": "IconButton-module-scss-module__RwXaAa__primary",
  "secondary": "IconButton-module-scss-module__RwXaAa__secondary",
  "spinner": "IconButton-module-scss-module__RwXaAa__spinner",
});
